import * as types from '../actions';

const initialState = {
  items: [],
  loading: false,
  selected: [],
  error: null,
};

export default function todoReducer(state = initialState, action) {
  switch (action.type) {
    case types.TODO_GET_LIST:
      return { ...state, loading: true };
    case types.TODO_GET_LIST_SUCCESS:
      return { ...state, loading: false, items: action.payload };
    case types.TODO_GET_LIST_ERROR:
      return { ...state, loading: false, error: action.payload };
    case types.TODO_ADD_ITEM_SUCCESS:
      return { ...state, items: [action.payload, ...state.items] };
    case types.TODO_SELECTED_ITEMS_CHANGE:
      return { ...state, selected: action.payload };
    default:
      return state;
  }
}
